<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">商户：</span>
        </div>
        <el-select v-model="formData.enterpriseCode" filterable remote reserve-keyword placeholder="请输入关键词" :loading="enterpriseLoading" size="mini" style="width: 280px" :remote-method="enterpriseRemoteMethod">
          <el-option v-for="item in enterpriseList" :key="item.code" :label="item.enterpriseName" :value="item.code"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">购券人：</span>
        </div>
        <el-select v-model="formData.personCode" filterable remote reserve-keyword placeholder="请输入关键词" :loading="personLoading" size="mini" style="width: 280px" :remote-method="personRemoteMethod">
          <el-option v-for="item in personList" :key="item.code" :label="item.name" :value="item.code"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">优惠券：</span>
        </div>
        <el-select v-model="formData.couponCode" size="small" style="width: 280px">
          <el-option v-for="item in couponList" :key="item.code"
                     :label="item._label" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">出售时间：</span>
        </div>
        <el-date-picker v-model="formData.saleTime" type="date" style="width: 280px" value-format="yyyy-MM-dd" placeholder="付款时间" size="small"></el-date-picker>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">出售份数：</span>
        </div>
        <el-input-number controls-position="right" v-model="formData.saleNum" size="small" style="width: 280px" :maxlength="64" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">出售总金额：</span>
        </div>
        <el-input v-model="formData.saleMoney" size="small" style="width: 280px" disabled>
          <template slot="append">元</template>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">出售总张数：</span>
        </div>
        <el-input v-model="formData.saleTotalNum" size="small" style="width: 280px" disabled>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">付款方式：</span>
        </div>
        <el-select v-model="formData.payType" size="small" style="width: 280px">
          <el-option v-for="item in payTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">付款时间：</span>
        </div>
        <el-date-picker v-model="formData.payTime" type="date" style="width: 280px" value-format="yyyy-MM-dd" placeholder="付款时间" size="small"></el-date-picker>
      </div>
      <div class="form-line">
        <div class="textBox">
<!--          <b class="red">*</b>-->
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" size="small" style="width: 280px" />
      </div>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import md5 from 'js-md5'
  import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../../components/Button/ButtonCancel'
  import {api} from '../../../api/ParkingService'
  import {errorHandler} from '../../../../utils/errorHandler'
  import {nError, nSuccess} from '../../../../utils/notice'
  import {pattern} from '../../../../utils/regular'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'coupon-put-on-the-shelves-add',
    data () {
      return {
        breadcrumb: [{
          value: '智慧停车',
          name: 'parking-device-management'
        }, {
          value: '优惠券出售'
        }],
        mainTitle: '优惠券出售',
        subheading: '',
        pickerOptions2: {
          shortcuts: [{
            text: '未来一年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 365)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '未来三年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 365 * 3)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '未来五年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 365 * 5)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        payTypeList: [
          { code: '1', name: '微信' },
          { code: '2', name: '支付宝' },
          { code: '3', name: '银行转账' },
          { code: '4', name: '现金' },
          { code: '5', name: '其他' },
        ],
        enterpriseLoading: false,
        enterpriseList: [],
        personLoading: false,
        personList: [],
        couponList: [],
        formData: {
          enterpriseName: '',
          enterpriseCode: '',
          personName: '',
          personCode: '',
          couponCode: '',
          couponName: '',
          couponType: '',
          denominationMoney: '',
          denominationHour: '',
          denominationMinite: '',
          couponNum: '',
          couponPrice: '',
          saleTime: '',
          saleNum: 1,
          saleMoney: '',
          payType: '',
          payTime: '',
          memo: '',
          saleTotalNum:''
        }
      }
    },
    created () {
      this.enterpriseRemoteMethod()
      this.getCouponList()
    },
    methods: {
      // 住户搜索
      enterpriseRemoteMethod (query) {
        this.enterpriseLoading = true;
        this.$axios.post(api.getEnterpriseList, {
          searchKey: query
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.enterpriseLoading = false;
              let data = res.data.data
              this.enterpriseList = data
            }
          })
          .catch(errorHandler('获取住户列表失败'))
      },
      // 人员搜索
      personRemoteMethod (query) {
        if (this.formData.enterpriseCode) {
          this.personLoading = true;
          this.$axios.post(api.getPersonListByEnterpriseCode, {
            enterpriseCode: this.formData.enterpriseCode,
            searchKey: query
          })
            .then(res => {
              if (res.data.retCode === 1) {
                this.personLoading = false;
                let data = res.data.data
                this.personList = data
              }
            })
            .catch(errorHandler('获取人员列表失败'))
        }
      },
      // 获取优惠券列表
      getCouponList () {
        this.$axios.post(api.parkingCouponIssueGetList, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              data.map(v => {
                if (v.type === "金额") {
                  v.denomination = `面额:${v.denominationMoney}元`;
                } else {
                  if (!v.denominationHour) {
                    v.denomination = `面额:${v.denominationMinite}分钟`;
                  } else {
                    v.denomination = `面额:${
                      v.denominationHour
                    }小时${v.denominationMinite || 0}分钟`;
                  }
                }
                v._label = `${v.name}/${v.denomination}/张数:${v.num}/售价:${v.price}元`
              })
              this.couponList = data
            }
          })
          .catch(errorHandler('获取优惠券列表失败'))
      },
      toMangePage () {
        this.$router.push({
          name: 'coupon-sell'
        })
      },
      // 确认添加
      confirm () {
        if (!this.formData.enterpriseCode) {
          nError('请选择商户')
          return false
        }
        if (!this.formData.personCode) {
          nError('请选择购券人')
          return false
        }
        if (!this.formData.couponCode) {
          nError('请选择优惠券')
          return false
        }
        if (!this.formData.saleTime) {
          nError('请选择出售时间')
          return false
        }
        if (!this.formData.saleNum) {
          nError('请输入出售数量')
          return false
        }
        if (!this.formData.payType) {
          nError('请选择付款方式')
          return false
        }
        if (!this.formData.payTime) {
          nError('请选择付款时间')
          return false
        }
        this.enterpriseList.map(v => {
          if (v.code === this.formData.enterpriseCode) {
            this.formData.enterpriseName = v.enterpriseName
          }
        })
        this.personList.map(v => {
          if (v.code === this.formData.personCode) {
            this.formData.personName = v.name
          }
        })
        this.$axios.post(api.parkingCouponSaleAdd, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('操作成功')
              this.toMangePage()
            }
          })
          .catch(errorHandler('操作失败'))
      },
      cancel () {
        this.toMangePage()
      }
    },
    watch: {
      'formData.enterpriseCode': {
        handler(newName, oldName) {
          this.personRemoteMethod()
        },
        deep: true
      },
      'formData.type': {
        handler(newName, oldName) {
          if (this.formData.type === '金额') {
            this.denominationHour = ''
            this.denominationMinite = ''
          } else if (this.formData.type === '时长') {
            this.denominationMoney = ''
          }
        },
        deep: true
      },
      'formData.couponCode': {
        handler(newName, oldName) {
          this.couponList.map(v => {
            if (v.code === this.formData.couponCode) {
              this.formData.couponName = v.name
              this.formData.couponType = v.type
              this.formData.denominationMoney = v.denominationMoney
              this.formData.denominationHour = v.denominationHour
              this.formData.denominationMinite = v.denominationMinite
              this.formData.couponNum = v.num
              this.formData.couponPrice = v.price
              if (this.formData.saleNum) {
                this.formData.saleMoney = parseFloat(parseFloat(this.formData.couponPrice) * this.formData.saleNum).toFixed(2)
              }
              this.formData.saleTotalNum = this.formData.couponNum * this.formData.saleNum
            }
          })
        },
        deep: true
      },
      'formData.saleNum': {
        handler(newName, oldName) {
          this.formData.saleMoney = ''
          if (this.formData.couponPrice) {
            this.formData.saleMoney = parseFloat(parseFloat(this.formData.couponPrice) * this.formData.saleNum).toFixed(2)
          }
            this.formData.saleTotalNum = this.formData.couponNum * this.formData.saleNum
        },
        deep: true
      },
      couponTimeValue (val) {
        if (this.couponTimeValue) {
          this.formData.startTime = this.couponTimeValue[0] || ''
          this.formData.endTime = this.couponTimeValue[1] || ''
        } else {
          this.formData.startTime = ''
          this.formData.endTime = ''
        }
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingCoupon/CouponSell/CouponSellAdd.vue